import { ShoppingBag } from "lucide-react";
import { Empty, PageHeader, StatusBadge } from "@/components/shared";
import { ShopifySyncBar } from "@/components/ShopifySyncBar";
import { fdt, inr, useApi } from "@/lib/api";

export default function OnlineOrders() {
  const { data, reload } = useApi("/online-orders");
  return (
    <div>
      <PageHeader title="Online Orders" subtitle="Orders placed on the Gamerz Nation Shopify storefront.">
        <ShopifySyncBar onSynced={reload} />
      </PageHeader>
      <div className="rounded-lg border bg-card overflow-x-auto">
        <table className="w-full text-sm" data-testid="online-orders-table">
          <thead><tr className="border-b bg-muted/40 text-xs text-muted-foreground">
            {["Order", "Customer", "Items", "Payment", "Fulfillment", "Placed", "Total"].map((h) => <th key={h} className="text-left font-medium px-4 py-2.5">{h}</th>)}
          </tr></thead>
          <tbody>
            {data?.map((o) => (
              <tr key={o.id} className="border-b last:border-0 align-top" data-testid={`order-row-${o.orderNumber.replace("#", "")}`}>
                <td className="px-4 py-3"><div className="font-mono font-medium">{o.orderNumber}</div><div className="text-[11px] text-muted-foreground font-mono">{o.shopifyOrderId.split("/").pop()}</div></td>
                <td className="px-4 py-3"><div className="font-medium">{o.customerName}</div><div className="text-xs text-muted-foreground">{o.customerEmail}</div><div className="text-xs text-muted-foreground">{o.customerPhone}</div></td>
                <td className="px-4 py-3 space-y-1">{o.lineItems.map((li, i) => <div key={i} className="text-xs"><span className="num text-muted-foreground">{li.quantity}×</span> {li.title}</div>)}</td>
                <td className="px-4 py-3"><StatusBadge status={o.financialStatus} /></td>
                <td className="px-4 py-3"><StatusBadge status={o.fulfillmentStatus} /></td>
                <td className="px-4 py-3 text-xs text-muted-foreground whitespace-nowrap">{fdt(o.placedAt)}</td>
                <td className="px-4 py-3 num font-semibold">{inr(o.totalAmount)}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {data?.length === 0 && <Empty text={<><ShoppingBag className="h-5 w-5 mx-auto mb-2" />No online orders yet</>} />}
      </div>
    </div>
  );
}
